const AmazonAssociateNotice = () => {
  return (
    <div className="py-2 px-4 text-right text-xs text-gray-600">
      当サイトはAmazonアソシエイト・プログラムの参加者です。
    </div>
  );
};

export default AmazonAssociateNotice;
